import get from "lodash/get"
import moment from "moment"
import { SCALE_CODES } from "../constants"

/**
 * @description Returns scroll limits based on current timeline state
 * @param {object} params
 * @param {object} plan
 * @returns {object}
 * */
const getScrollLimit = (params, plan) => {
  const { start, end, scale, previousRange } = params

  const startDate = moment(start)
  const endDate = moment(end)

  const scaleName = SCALE_CODES[scale]

  // Calculates scroll direction ('asc' for scrolling to future (right))
  const scrollDirection = start > previousRange.start ? `asc` : `desc`

  const hasActivePlan = !!get(plan, `data`)
  const planStart = get(plan, `data.startDateTime`)
  // The point of '- 1' is to set the end of the day last day,
  // not the start of the next day if the planEnd is 00:00
  const planEnd = get(plan, `data.endDateTime`) - 1

  const scrollLimit = {
    start: null,
    end: null,
  }

  // New timeline limits are set here based on scroll direction
  if (scrollDirection === `asc`) {
    scrollLimit.start = startDate.startOf(scaleName).valueOf()
    scrollLimit.end = startDate.endOf(scaleName).valueOf() - 1000
  } else {
    scrollLimit.start = endDate.startOf(scaleName).valueOf()
    scrollLimit.end = endDate.endOf(scaleName).valueOf()
  }

  // If there is active plan, we should 'cut' limits to it's dates
  if (hasActivePlan) {
    if (scrollLimit.start < planStart && scrollLimit.end > planEnd) {
      scrollLimit.start = moment(planStart)
        .startOf(scaleName)
        .valueOf()
      scrollLimit.end = moment(planEnd)
        .endOf(scaleName)
        .valueOf()
    } else if (scrollLimit.start < planStart) {
      scrollLimit.start = moment(planStart)
        .startOf(scaleName)
        .valueOf()
    } else if (scrollLimit.end > planEnd) {
      scrollLimit.end = moment(planEnd)
        .endOf(scaleName)
        .valueOf()
    }
  }
  return scrollLimit
}

export default getScrollLimit
